import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

// Handles the return from Emergent Google OAuth: {origin}/room#session_id=...
export default function AuthCallback() {
  const { refreshMe, loadCharacter } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      const sid = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
      try {
        if (sid) await api.post("/auth/google/session", { session_id: sid });
        window.history.replaceState(null, "", window.location.pathname);
        const u = await refreshMe();
        const ch = u ? await loadCharacter() : null;
        nav(ch ? "/room" : u ? "/create" : "/", { replace: true });
      } catch {
        window.history.replaceState(null, "", "/");
        nav("/", { replace: true });
      }
    })();
  }, [refreshMe, loadCharacter, nav]);

  return (
    <div className="h-[100dvh] flex items-center justify-center bg-[#F8FAFC] text-[#16A34A] font-display text-2xl">
      signing you in…
    </div>
  );
}
